import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

import { tryToRefreshToken } from './utils/refresh';

const onResponse = (resp: AxiosResponse) => {
  if (resp.status == 204 && !resp.data) {
    resp.data = [];
  }

  return resp.data;
};

const onResponseError = (client: AxiosInstance) => (error: AxiosError) => {
  const message: string = error.message ?? '';
  const status = error.response?.status ?? 500;

  if (error) {
    if (status === 401) {
      return tryToRefreshToken(client, error.config);
    }
  }

  return Promise.reject({ ...error, status, message });
};

export { onResponse, onResponseError };
